import React from "react";
import {
  ConfirmDeleteModal,
  ImageUploadField,
  Input,
  Modal,
  ModalActions,
  MultipleImageUploadField,
  TextArea,
} from "./ChaafoCommonComponents";
import ClientSearchSelect from "../common/ClientSearchSelect";

export default function ChaafoModals({
  loading,

  showCategoryModal,
  setShowCategoryModal,
  categoryMode,
  categoryForm,
  setCategoryForm,
  categoryImageUploading,
  handleCategoryImageUpload,
  handleSaveCategory,

  showBannerModal,
  setShowBannerModal,
  bannerForm,
  setBannerForm,
  bannerImageUploading,
  handleBannerImageUpload,
  handleSaveBanner,

  deleteModal,
  setDeleteModal,
  handleConfirmDelete,

  showRestaurantModal,
  setShowRestaurantModal,
  restaurantMode,
  restaurantForm,
  setRestaurantForm,
  restaurantImageUploading,
  handleRestaurantImageUpload,
  handleSaveRestaurant,
  clients = [],
  selectedClientCode = "",
}) {
  const closeDeleteModal = () => {
    setDeleteModal({
      open: false,
      type: "",
      item: null,
      title: "",
      message: "",
      fkUserId: "",
      selectedClientCode: "",
    });
  };

  const handleRemoveRestaurantImage = (removeIndex) => {
    setRestaurantForm((prev) => {
      const images = prev.restaurantProfileImage
        ? prev.restaurantProfileImage
            .split(",")
            .map((image) => image.trim())
            .filter(Boolean)
        : [];

      const nextImages = images.filter((_, index) => index !== removeIndex);

      return {
        ...prev,
        restaurantProfileImage: nextImages.join(", "),
      };
    });
  };

  const getClientUserId = (client) =>
    String(
      client?.userid ??
        client?.userId ??
        client?.user_id ??
        client?.us_code ??
        client?.value ??
        client?.id ??
        "",
    ).trim();

  const getClientCode = (client) =>
    String(
      client?.us_code ??
        client?.userid ??
        client?.userId ??
        client?.user_id ??
        client?.value ??
        client?.id ??
        "",
    ).trim();

  const getClientName = (client) =>
    client?.organization_name ??
    client?.us_name ??
    client?.us_loginid ??
    client?.us_email ??
    client?.name ??
    client?.label ??
    "";

  const getAspectRatioStyle = (ratio = "16:9") => {
    const value = String(ratio || "16:9").trim();

    const ratioMap = {
      "1:1": "1 / 1",
      "4:3": "4 / 3",
      "4:5": "4 / 5",
      "16:9": "16 / 9",
    };

    return ratioMap[value] || "16 / 9";
  };

  return (
    <>
      {/* CATEGORY MODAL */}
      {/* CATEGORY MODAL */}
      {showCategoryModal && (
        <Modal
          title={categoryMode === "edit" ? "Edit Category" : "Add Category"}
          onClose={() => setShowCategoryModal(false)}
        >
          <form onSubmit={handleSaveCategory} className="space-y-4">
            <Input
              label="Category Name"
              value={categoryForm.categoryName}
              onChange={(value) =>
                setCategoryForm((prev) => ({
                  ...prev,
                  categoryName: value,
                }))
              }
              placeholder="Enter category name"
              required
            />

            <ImageUploadField
              label="Category Image"
              imageUrl={categoryForm.categoryImage}
              uploading={categoryImageUploading}
              onUpload={handleCategoryImageUpload}
              onRemove={() =>
                setCategoryForm((prev) => ({
                  ...prev,
                  categoryImage: "",
                }))
              }
            />

            <TextArea
              label="Category Description"
              value={categoryForm.categoryDescription}
              onChange={(value) =>
                setCategoryForm((prev) => ({
                  ...prev,
                  categoryDescription: value,
                }))
              }
              placeholder="Write category description..."
            />

            {categoryMode === "edit" && (
              <label className="block">
                <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Category Status
                </span>

                <select
                  value={categoryForm.activeStatus || "Y"}
                  onChange={(event) =>
                    setCategoryForm((prev) => ({
                      ...prev,
                      activeStatus: event.target.value,
                    }))
                  }
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                >
                  <option value="Y">Active</option>
                  <option value="N">Inactive</option>
                </select>

                <p className="mt-1.5 text-xs text-slate-500">
                  Active categories use Y. Inactive categories use N.
                </p>
              </label>
            )}

            <ModalActions
              loading={loading}
              onCancel={() => setShowCategoryModal(false)}
              submitText={
                categoryMode === "edit" ? "Update Category" : "Save Category"
              }
            />
          </form>
        </Modal>
      )}

      {showBannerModal && (
        <Modal
          title={bannerForm.id ? "" : "Add Banner"}
          onClose={() => setShowBannerModal(false)}
        >
          <form onSubmit={handleSaveBanner} className="space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-semibold text-slate-700">
                Select Client ID
              </label>

              <ClientSearchSelect
                clients={clients}
                value={
                  bannerForm.selectedClientCode || bannerForm.fkUserId || ""
                }
                onChange={(client) => {
                  const userId = getClientUserId(client);
                  const code = getClientCode(client);

                  setBannerForm((prev) => ({
                    ...prev,
                    fkUserId: userId,
                    selectedClientCode: code || userId,
                  }));
                }}
                placeholder={
                  clients.length === 0 ? "No clients found" : "Select client ID"
                }
                searchPlaceholder="Search client by ID..."
                className="w-full"
              />

              {bannerForm.fkUserId && (
                <p className="mt-1 text-xs font-medium text-emerald-600">
                  Selected Client ID: {bannerForm.fkUserId}
                </p>
              )}
            </div>

            <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
              <div
                className="relative w-full overflow-hidden bg-slate-100"
                style={{
                  aspectRatio: getAspectRatioStyle(bannerForm.aspectRatio),
                }}
              >
                {bannerForm.imagePreviewUrl || bannerForm.imageUrl ? (
                  <img
                    src={bannerForm.imagePreviewUrl || bannerForm.imageUrl}
                    alt="Banner Preview"
                    className="h-full w-full object-cover"
                    onError={(event) => {
                      event.currentTarget.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="flex h-full w-full items-center justify-center text-sm font-semibold text-slate-400">
                    Banner preview will appear here
                  </div>
                )}

                <div className="absolute left-3 top-3 flex flex-wrap gap-2">
                  {bannerForm.fkUserId && (
                    <span className="rounded-full bg-black/70 px-3 py-1 text-[11px] font-black uppercase tracking-wide text-white backdrop-blur">
                      {bannerForm.fkUserId}
                    </span>
                  )}

                  {bannerForm.offer && (
                    <span className="rounded-full bg-emerald-500 px-3 py-1 text-[11px] font-black uppercase tracking-wide text-white shadow-sm">
                      {bannerForm.offer}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <label className="block">
                <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Banner Type
                </span>

                <select
                  value={bannerForm.offer || ""}
                  onChange={(event) =>
                    setBannerForm((prev) => ({
                      ...prev,
                      offer: event.target.value,
                    }))
                  }
                  required
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700 outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                >
                  <option value="">Select banner type</option>
                  <option value="offer">Offer</option>
                  <option value="Traditional">Traditional</option>
                  <option value="offer-page">Offer Page</option>
                </select>
              </label>

              <label className="block">
                <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Aspect Ratio
                </span>

                <select
                  value={bannerForm.aspectRatio || "16:9"}
                  onChange={(event) =>
                    setBannerForm((prev) => ({
                      ...prev,
                      aspectRatio: event.target.value,
                    }))
                  }
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                >
                  <option value="1:1">1:1</option>
                  <option value="4:3">4:3</option>
                  <option value="4:5">4:5</option>
                  <option value="16:9">16:9</option>
                </select>
              </label>
            </div>

            <label className="block">
              <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                Banner Show On
              </span>

              <select
                value={bannerForm.desc || "Home Screen"}
                onChange={(event) =>
                  setBannerForm((prev) => ({
                    ...prev,
                    desc: event.target.value,
                  }))
                }
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
              >
                <option value="Home Screen">Home Screen</option>
                <option value="Main Menu">Main Menu</option>
              </select>
            </label>

            <label className="block">
              <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                Platform
              </span>

              <select
                value={bannerForm.plateform || "App"}
                onChange={(event) =>
                  setBannerForm((prev) => ({
                    ...prev,
                    plateform: event.target.value,
                  }))
                }
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
              >
                <option value="App">App</option>
                <option value="Web">Web</option>
                <option value="Both">Both</option>
              </select>
            </label>

            <ImageUploadField
              label="Banner Image"
              imageUrl={bannerForm.imagePreviewUrl || bannerForm.imageUrl}
              uploading={bannerImageUploading}
              onUpload={handleBannerImageUpload}
              onRemove={() =>
                setBannerForm((prev) => ({
                  ...prev,
                  imageUrl: "",
                  imagePreviewUrl: "",
                }))
              }
            />

            <ModalActions
              loading={loading}
              onCancel={() => setShowBannerModal(false)}
              submitText={bannerForm.id ? "Update Banner" : "Save Banner"}
            />
          </form>
        </Modal>
      )}

      {deleteModal.open && (
        <ConfirmDeleteModal
          title={deleteModal.title}
          message={deleteModal.message}
          loading={loading}
          onCancel={closeDeleteModal}
          onConfirm={handleConfirmDelete}
        />
      )}

      {showRestaurantModal && (
        <Modal
          title={
            restaurantMode === "edit" ? "Edit Restaurant" : "Add Restaurant"
          }
          onClose={() => setShowRestaurantModal(false)}
        >
          <div className="mb-4">
            <label className="mb-1.5 block text-sm font-semibold text-slate-700">
              Select Restaurant User
            </label>

            <ClientSearchSelect
              clients={clients}
              value={
                restaurantForm.selectedClientCode || restaurantForm.userId || ""
              }
              onChange={(client) => {
                const userId = getClientUserId(client);
                const code = getClientCode(client);

                setRestaurantForm((prev) => ({
                  ...prev,
                  userId,
                  selectedClientCode: code || userId,
                  restaurantName:
                    restaurantMode === "add"
                      ? prev.restaurantName || getClientName(client)
                      : prev.restaurantName,
                }));
              }}
              placeholder={
                clients.length === 0
                  ? "No users found"
                  : "Select restaurant user"
              }
              searchPlaceholder="Search restaurant by name or code..."
              className="w-full"
            />

            {restaurantForm.userId && (
              <p className="mt-1 text-xs font-medium text-emerald-600">
                Selected User ID: {restaurantForm.userId}
              </p>
            )}
          </div>

          <form onSubmit={handleSaveRestaurant} className="space-y-4">
            {restaurantMode === "edit" && (
              <Input
                label="Restaurant Name"
                value={restaurantForm.restaurantName}
                onChange={(value) =>
                  setRestaurantForm((prev) => ({
                    ...prev,
                    restaurantName: value,
                  }))
                }
                placeholder="Enter restaurant name"
              />
            )}

            <MultipleImageUploadField
              label="Restaurant Images"
              imageUrls={restaurantForm.restaurantProfileImage}
              uploading={restaurantImageUploading}
              onUpload={handleRestaurantImageUpload}
              onRemoveImage={handleRemoveRestaurantImage}
            />

            <Input
              label="Restaurant Address"
              value={restaurantForm.restaurantAddress}
              onChange={(value) =>
                setRestaurantForm((prev) => ({
                  ...prev,
                  restaurantAddress: value,
                }))
              }
              placeholder="Enter restaurant address"
            />

            <label className="block">
              <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                Serving Type
              </span>

              <select
                value={restaurantForm.servingType}
                onChange={(event) =>
                  setRestaurantForm((prev) => ({
                    ...prev,
                    servingType: event.target.value,
                  }))
                }
                required
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
              >
                <option value="">Select serving type</option>
                <option value="V">Veg</option>
                <option value="N">Non-Veg</option>
                <option value="B">Both</option>
              </select>
            </label>

            {restaurantMode === "edit" && (
              <label className="block">
                <span className="mb-1.5 block text-sm font-semibold text-slate-700">
                  Restaurant Status
                </span>

                <select
                  value={restaurantForm.activeStatus || "Y"}
                  onChange={(event) =>
                    setRestaurantForm((prev) => ({
                      ...prev,
                      activeStatus: event.target.value,
                    }))
                  }
                  className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm outline-none transition focus:border-emerald-400 focus:bg-white focus:ring-4 focus:ring-emerald-100"
                >
                  <option value="Y">Active</option>
                  <option value="N">Inactive</option>
                </select>

                <p className="mt-1.5 text-xs text-slate-500">
                  Active sends Y, Inactive sends N to the update API.
                </p>
              </label>
            )}

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
              <Input
                label="Offer"
                value={restaurantForm.restaurantOffer}
                onChange={(value) =>
                  setRestaurantForm((prev) => ({
                    ...prev,
                    restaurantOffer: value,
                  }))
                }
                placeholder="Flat 20% OFF"
              />

              <Input
                label="Ratings"
                value={restaurantForm.ratings}
                onChange={(value) =>
                  setRestaurantForm((prev) => ({
                    ...prev,
                    ratings: value,
                  }))
                }
                placeholder="4.5"
              />

              <Input
                label="Starting Price"
                value={restaurantForm.startingPrice}
                onChange={(value) =>
                  setRestaurantForm((prev) => ({
                    ...prev,
                    startingPrice: value,
                  }))
                }
                placeholder="199"
              />
            </div>

            <TextArea
              label="Restaurant Description"
              value={restaurantForm.restaurantDescription}
              onChange={(value) =>
                setRestaurantForm((prev) => ({
                  ...prev,
                  restaurantDescription: value,
                }))
              }
              placeholder="Write restaurant description..."
            />

            <ModalActions
              loading={loading}
              onCancel={() => setShowRestaurantModal(false)}
              submitText={
                restaurantMode === "edit"
                  ? "Update Restaurant"
                  : "Save Restaurant"
              }
            />
          </form>
        </Modal>
      )}
    </>
  );
}
